import React, { useState, useEffect } from "react";
import ReactPaginate from "react-paginate";
import { FaMoneyCheckAlt, FaClock } from "react-icons/fa";
import { useSelector, useDispatch } from "react-redux";
import { fetchData } from "../redux/apiSlice";
import { toastify, userlogout, clearuser } from "../redux/controller";
import { useNavigate } from "react-router-dom";

export default function Earnings() {

  const Navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(0);
  const [perPage, setperPage] = useState(10);
  const userinfo = useSelector((state) => state.userdata.userdata);
  const usertoken = useSelector((state) => state.userdata.usertoken);

  const [pendingEarnings, setPendingEarings] = useState(0);
  const [totalEarnings, setTotalEarnings] = useState(0);
  const [affiliateTotalEarnings, setAffiliateTotalEarnings] = useState(0);
  const [minimumPayout, setMimimumPayout] = useState(0);
  const [paymentHisotryData, setPaymentHisotryData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showDialog, setShowDialog] = useState(false);
  const [showLoadingOnGenerate, setShowLoadingOnGenerate] = useState(false);

  const [amount, setAmount] = useState("");
  const [error, setError] = useState("");


  const handleRequestPayment = () => {
    setShowDialog(true);
  };

  const dispatch = useDispatch();

  useEffect(() => {
    getSettings();
    getTotalEarnings();
    getPaymentHisotry();
  }, []);


  const getTotalEarnings = async () => {
    var response = await dispatch(
      fetchData({
        apiurl: "/auth/user/gettotalearnings",
        userid: userinfo._id,
        headers: { "x-access-token": usertoken },
      })
    );

    if (response.payload.status === 200 || response.payload.status === 201) {
      setPendingEarings(response.payload.totalAmount);
      setTotalEarnings(response.payload.total_earning_amount);
      setAffiliateTotalEarnings(response.payload.affiliateTotalEarnings || 0);
    }
  };


  const getSettings = async () => {
    var response = await dispatch(
      fetchData({
        apiurl: "/settings/getsettings",
        headers: { "x-access-token": usertoken },
      })
    );

    if (response.payload && response.payload.setting && response.payload.setting.minimumPayout) {
      setMimimumPayout(response.payload.setting.minimumPayout)
    } else if (
      response.payload.response &&
      response.payload.response.data &&
      response.payload.response.data.message
    ) {
      // toastify({ message: response.payload.response.data.message });
      if (
        response.payload.response.data.message === "Invalid token provided!" || response.payload.response.data.message === "No token provided!"
      ) {
        clearuser();
        userlogout();
        Navigate("/");
        window.location.reload();
      }
    }
  };

  const getPaymentHisotry = async () => {
    var response = await dispatch(
      fetchData({
        apiurl: "/auth/user/payment-history",
        userId: userinfo._id,
        headers: { "x-access-token": usertoken },
      })
    );

    if (response.payload && response.payload.payment_history && response.payload.payment_history.length > 0) {
      setPaymentHisotryData(response.payload.payment_history)
    }
  };


  const reuestPayment = async () => {
    if (pendingEarnings >= minimumPayout) {

      console.log("Amount ", Number(amount));

      if (Number(amount) < minimumPayout) {
        setError(`Please enter the amount equal to or greater than $${minimumPayout}`);
        return;
      }
      if (Number(amount) > pendingEarnings) {
        setError(`Please enter the amount not greather than your earnings, $${pendingEarnings}`);
        return;
      }

      if (loading) return; // Prevent double-clicks
      setLoading(true);


      var response = await dispatch(
        fetchData({
          apiurl: "/auth/user/request-payment",
          userid: userinfo._id,
          amount: Number(amount),
          headers: { "x-access-token": usertoken },
        })
      );

      setLoading(false);

      if (response.payload && response.payload.success && response.payload.message) {
        toastify({
          message: response.payload.message,
        });
        setShowDialog(false)
      } else if (response.payload && response.payload.response && response.payload.response.data && response.payload.response.data.message) {
        // toastify({
        //   message: response.payload.message,
        // });
        setError(response.payload.response.data.message)
      }
      getSettings();
      getTotalEarnings();
      getPaymentHisotry();
    } else {
      // toastify({
      //   message: "You can request payment when minimum payment threshold reached",
      // });
      setError('You can request payment when minimum payment threshold reached')
    }
  };

  function convertdate(dateStr) {
    const date = new Date(dateStr);
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    const year = date.getFullYear();

    return `${month}/${day}/${year}`;
  }

  function inputperPage(e) {
    setperPage(Number(e.target.value));
    setCurrentPage(0);
  }

  const pageCount = Math.ceil(paymentHisotryData.length / perPage);

  const offset = currentPage * perPage;
  const currentPageData = paymentHisotryData.slice(offset, offset + perPage);

  const handlePageChange = ({ selected }) => {
    setCurrentPage(selected);
  };
  const isDisabled = loading || pendingEarnings < minimumPayout;

  const handlesuccessPopup = () => {
    setShowDialog(false);
  };

  const onGenerateStripeLink = async () => {
    try {

      setShowLoadingOnGenerate(true)
      var response = await dispatch(
        fetchData({
          apiurl: "/auth/user/generate-stripe-link",
          userId: userinfo._id,
          headers: { "x-access-token": usertoken },
        })
      );

      setShowLoadingOnGenerate(false)
      // Check for successful response
      if (response?.payload?.success && response.payload.login_url) {
        // Open the login URL in a new tab
        window.open(response.payload.login_url, "_blank");
      } else {
        toastify({
          message: "Error on generating stripe link. Please contact to admin.",
        });
      }
    } catch (err) {
      console.error("Error generating Stripe login link:", err);
      // Optionally, show a toast or alert here
    }
  };


  return (
    <>
      <div className="earnings-main">
        <div className="earnings-top">
          <h1>Overall Earnings (All Seasons)</h1>
          <button onClick={handleRequestPayment}
            disabled={isDisabled}
          >Request Payment</button>
        </div>
        <div className="earnings-dashboard">
          <div className="earnings-card pending">
            <div className="earnings-icon">
              <FaClock />
              <h3>Total Earnings:</h3>
            </div>
            <div>
              <p>${totalEarnings.toFixed(2)}</p>
            </div>
          </div>
          <div className="earnings-card paid">
            <div className="earnings-icon">
              <FaMoneyCheckAlt />
              <h3>Earning Balance:</h3>
            </div>
            <div>
              <p>${pendingEarnings.toFixed(2)}</p>
            </div>
          </div>
          <div className="earnings-card affiliate">
            <div className="earnings-icon">
              <FaMoneyCheckAlt />
              <h3>Referral Earnings:</h3>
            </div>
            <div>
              <p>${affiliateTotalEarnings.toFixed(2)}</p>
            </div>
          </div>
        </div>
        <div className="earning-info-text">
          You can request a payment once your <b>Earning Balance</b> reach the minimum payout threshold of ${minimumPayout}.
        </div>
      </div>

      <div className="stripe-link-generate">
        <div>
          <h4>
            <svg width="24px" height="24px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M12 17.75C12.4142 17.75 12.75 17.4142 12.75 17V11C12.75 10.5858 12.4142 10.25 12 10.25C11.5858 10.25 11.25 10.5858 11.25 11V17C11.25 17.4142 11.5858 17.75 12 17.75Z" fill="#be7637"></path> <path d="M12 7C12.5523 7 13 7.44772 13 8C13 8.55228 12.5523 9 12 9C11.4477 9 11 8.55228 11 8C11 7.44772 11.4477 7 12 7Z" fill="#be7637"></path> <path fill-rule="evenodd" clip-rule="evenodd" d="M1.25 12C1.25 6.06294 6.06294 1.25 12 1.25C17.9371 1.25 22.75 6.06294 22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C6.06294 22.75 1.25 17.9371 1.25 12ZM12 2.75C6.89137 2.75 2.75 6.89137 2.75 12C2.75 17.1086 6.89137 21.25 12 21.25C17.1086 21.25 21.25 17.1086 21.25 12C21.25 6.89137 17.1086 2.75 12 2.75Z" fill="#be7637"></path> </g></svg>
            Go to your Stripe Connect account by clicking the button

          </h4>
          <button className="stripe-link-button" onClick={onGenerateStripeLink}>{showLoadingOnGenerate ? (
            <div className="spinner-payment" />
          ) : (
            'Go to Stripe'
          )}</button>
        </div>
      </div>

      <div className="add-form earninglist-table">
        <div className="add-table">
          <table className="table">
            <thead>
              <tr>
                <th scope="col">Transaction ID</th>
                <th scope="col">Payment Status (Paid / Pending)</th>
                <th scope="col">Paid Amount</th>
                <th scope="col">Credited Date</th>
              </tr>
            </thead>
            <tbody
              style={{
                display:
                  paymentHisotryData &&
                    paymentHisotryData.length
                    ? "contents"
                    : "table-caption",
              }}
            >

              {currentPageData.length ? (
                currentPageData.map((reservation, index) => (
                  <tr key={index}>
                    <td>{reservation.transactionId}</td>
                    <td>{reservation.status == 'Done' ? 'Paid' : 'Pending'}</td>
                    <td>${reservation.amount}</td>
                    <td>{convertdate(reservation.date)}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colspan={4} className="header-empty">
                    No payment history found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {paymentHisotryData.length ? (
          <div className="rowperpage">
            <div className="perpagecount">
              Rows Per Page&nbsp;
              <select onChange={inputperPage} value={perPage}>
                <option value={10}>10</option>
                <option value={50}>50</option>
                <option value={100}>100</option>
                <option value={150}>150</option>
                <option value={200}>200</option>
              </select>
            </div>
            <ReactPaginate
              previousLabel={"Previous"}
              nextLabel={"Next"}
              breakLabel={"..."}
              pageCount={pageCount}
              marginPagesDisplayed={2}
              pageRangeDisplayed={perPage}
              onPageChange={handlePageChange}
              containerClassName={"pagination custom-pagination"}
              activeClassName={"active"}
            // forcePage={currentPage}
            />
          </div>
        ) : null}
      </div>


      {showDialog && (
        <div className="chagesuccess-popup request-payment">
          <div className="chagesuccess-content ">

            <div className="chagesuccess-contentdiv">
              <div className="modal_head">
                <h3>Payment Request Details</h3>
                <i className="fa-solid fa-xmark" onClick={handlesuccessPopup}></i>
              </div>
              <div className="dialog-info">
                <p>Stripe Email:<strong> {userinfo.email}</strong> </p>
                <p>Stripe Account ID:<strong>{userinfo.stripeaccount}</strong> </p>
                <p>Account Balance:<strong>${pendingEarnings.toFixed(2)}</strong> </p>
                <p>
                  Expected Credit Date: <strong>{new Date().toLocaleDateString('en-US')}</strong>
                </p>
                <p>Stripe Fees:<strong>$0</strong></p>
              </div>

              <div className="modal_footer">
                <div className="dialog-input">
                  <label>Enter Amount to Request:</label>
                  <input
                    type="number"
                    value={amount}
                    onChange={(e) => {
                      const val = e.target.value;
                      console.log("Value ", val)
                      // Allow only digits and empty value
                      if (/^\d*$/.test(val)) {
                        setAmount(val);
                      }
                    }}
                    placeholder="Enter amount"
                  />

                  {error && <div className="error-text">{error}</div>}
                </div>

                <div className="dialog-actions">
                  <button className="cancel-btn" onClick={handlesuccessPopup}>Cancel</button>
                  <button className="request-btn"
                    disabled={isDisabled}
                    onClick={reuestPayment}>{loading ? (
                      <div className="spinner-payment" />
                    ) : (
                      'Request Payment'
                    )}</button>
                </div>
              </div>

            </div>
          </div>
        </div>
      )}
    </>
  );
}
